export default __webpack_public_path__ + "static/media/kas.3ec72f60.png";